export const WEBSITE_URI = "https://www.biondapp.com/"

export const DEFAULT_ENDPOINT =
    process.env.NODE_ENV === "production"
        ? "/wp-json/wp/v2"
        : `${WEBSITE_URI}wp-json/wp/v2`;



// WEBPACK FOOTER //
// ./src/constants/variables.js